export default __webpack_public_path__ + "12a18f9f6cc5ae837471d54ae36cb85e.jpg";